// Rules of the form of an action (ActionDef.form) that do not depend on React: which control a choice gets, when the dialog may
// close, and the HTTP request of a command that answers with a report or a record to open.

import { uuidv7 } from '@confdeck/core-shared';

/** DESIGN.md: `Segmented` holds 2–5 neighbours, more options are a `Select`, with a search above 8. */
export const SEGMENTED_MAX = 5;
export const SELECT_SEARCH_MIN = 8;

export type ChoiceControl = 'segmented' | 'select' | 'select-search';
export function choiceControl(options: number): ChoiceControl {
  return options <= SEGMENTED_MAX ? 'segmented' : options > SELECT_SEARCH_MIN ? 'select-search' : 'select';
}

/** A dialog that waits for the server stays open: its answer (the report of a batch) is the only word the person gets. */
export const mayClose = (busy: boolean): boolean => !busy;

/**
 * The key of a send: the same answers sent again keep the key (the core replays the first answer instead of running the command
 * twice), other answers get a new one.
 */
export function txKeyFor(prev: { key: string; sig: string } | null, input: unknown): { key: string; sig: string } {
  const sig = JSON.stringify(input);
  return prev && prev.sig === sig ? prev : { key: uuidv7(), sig };
}

/** The request of a command over HTTP; `x-client-tx` is the idempotency key the socket path sends as `clientTxId`. */
export function commandRequest(input: unknown, clientTxId: string): RequestInit {
  return { method: 'POST', headers: { 'content-type': 'application/json', 'x-client-tx': clientTxId }, body: JSON.stringify(input) };
}
